<div class="med-switch-group">
  <med-switch
    *ngFor="let option of options"
    [size]="size"
    [label]="option.label"
    [labelClass]="labelClass"
    [disabled]="disabled || option.disabled"
    [required]="option.required"
    [value]="hasValue(option.value)"
    class="med-switch-group__item"
    (change)="onChangeHandler($event, option)"
  ></med-switch>
</div>

<div
  *ngIf="invalid"
  class="field__error-message"
>
  {{ errorMessage }}
</div>
